import { useMemo } from 'react';
import { EditPatientInfoQuery, useEditPatientInfoQuery } from '../../../../../../graphQL';
import { useDrilldownContext } from '../../../../helpers';
import { EditPatientInfoProvider, ProviderAssignmentMap } from '../../types';

type GetEditPatientInfoResult = {
  data?: EditPatientInfoQuery;
  loading: boolean;
  providers: EditPatientInfoProvider[];
  providerAssignmentMap: ProviderAssignmentMap;
};

export const useGetEditPatientInfo = (): GetEditPatientInfoResult => {
  const { user } = useDrilldownContext();

  const { data, loading } = useEditPatientInfoQuery({ variables: { userId: user.id } });

  const providers = useMemo<EditPatientInfoProvider[]>(
    () => data?.providersForUser?.data ?? [],
    [data?.providersForUser?.data]
  );

  const providerAssignmentMap = useMemo(
    () =>
      (user.careFlows ?? []).reduce((acc, careFlow) => {
        acc[careFlow.careType] = careFlow.provider?.id;
        return acc;
      }, {} as ProviderAssignmentMap),
    [user.careFlows]
  );

  return {
    data,
    loading,
    providers,
    providerAssignmentMap,
  };
};
